import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now"; //Material Imports

import ListItem from "@material-ui/core/ListItem";
import Avatar from "@material-ui/core/Avatar";
import Face from "@material-ui/icons/Face";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { withStyles } from "@material-ui/core/styles"; //Limitless Imports

import { withi18n } from "../hocs/i18n";
import UserAvatar from "../user-avatar/UserAvatar";
import { locale } from "../../../common/utils";
var messageLengthCount = 100;

var MessageHistoryListItem = /*#__PURE__*/function (_PureComponent) {
  _inherits(MessageHistoryListItem, _PureComponent);

  var _super = _createSuper(MessageHistoryListItem);

  function MessageHistoryListItem() {
    var _this;

    _classCallCheck(this, MessageHistoryListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.cropMessageTxt = function (messageTxt) {
      var newMessageTxt = messageTxt.length > messageLengthCount ? "".concat(messageTxt.substring(0, messageLengthCount), "...") : messageTxt;
      return newMessageTxt;
    };

    _this.showConversation = function () {
      _this.props.onClickHandle(_this.props.message);
    };

    return _this;
  }

  _createClass(MessageHistoryListItem, [{
    key: "getAvatarFace",
    value: function getAvatarFace() {
      var message = this.props.message; // We are getting image from Last dialogue, else default Avatar

      var expertDialogues = message.dialogues.filter(function (d) {
        return d.origin === "expert";
      });

      if (expertDialogues && expertDialogues.length) {
        var lastDialogue = expertDialogues[expertDialogues.length - 1];
        var thumbnail = message.expertAuthors[lastDialogue.userId] ? message.expertAuthors[lastDialogue.userId].thumbnail : null;
        return /*#__PURE__*/React.createElement(UserAvatar, {
          author: lastDialogue.author,
          thumbnail: thumbnail
        });
      }

      return /*#__PURE__*/React.createElement(Avatar, null, /*#__PURE__*/React.createElement(Face, null));
    }
  }, {
    key: "getTime",
    value: function getTime() {
      var _this$props = this.props,
          message = _this$props.message,
          t = _this$props.t;

      if (message.closedDate) {
        return distanceInWordsToNow(message.closedDate, {
          locale: locale(t)
        });
      } else {
        var lastDialogue = message.dialogues[message.dialogues.length - 1];
        return distanceInWordsToNow(lastDialogue.updated, {
          locale: locale(t)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          t = _this$props2.t,
          classes = _this$props2.classes;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ListItem, {
        button: true,
        onClick: this.showConversation,
        component: "div"
      }, this.getAvatarFace(), /*#__PURE__*/React.createElement("div", {
        className: classes.itemDetail
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.listRight
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        className: classes.itemText
      }, this.cropMessageTxt(this.props.message.body)), /*#__PURE__*/React.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React.createElement("div", {
        className: classes.itemStatus
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        className: classes.pendingText
      }, t(this.props.message.messageStatus)), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption"
      }, this.getTime())))));
    }
  }]);

  return MessageHistoryListItem;
}(PureComponent);

/* loading Style */
var styles = function styles() {
  return {
    pendingText: {
      display: "flex",
      flex: 1
    },
    itemStatus: {
      display: "flex",
      paddingLeft: "8px",
      paddingTop: "4px"
    },
    itemDetail: {
      flexDirection: "row",
      padding: "5px",
      cursor: "pointer",
      minWidth: 0,
      flex: 1
    },
    listRight: {
      display: "flex",
      cursor: "pointer"
    },
    itemText: {
      paddingLeft: "8px",
      wordBreak: "break-word",
      wordWrap: "break-word",
      minWidth: 0,
      flex: 1,
      color: "rgba(0, 0, 0, 0.87)"
    },
    keyboardArrowRight: {
      alignSelf: "center",
      paddingLeft: "5px"
    }
  };
};

export default withStyles(styles, {
  withTheme: true
})(withi18n(MessageHistoryListItem));